import { render } from "./PaymentInfo.vue?vue&type=template&id=90b0a37c"
import script from "./PaymentInfo.vue?vue&type=script&lang=js"
export * from "./PaymentInfo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__